import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import api from '../../api';
import { isNull } from '../../utility';
import { parseMessage } from '../../utility/Error';
// import { db } from "../../firebase";

const customStyles = {
  content: {
    top: '51%',
    height: '70%',
    left: '50%',
    right: 'auto',
    bottom: '0',
    width: '43%',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export default function CountryModal({
  closeModal,
  isOpen,
  fetchCountries,
  countryData,
  control,
}) {
  const [name, setName] = useState('');
  const [currency_name, setCurrencyName] = useState('');
  const [currency_symbol, setCurrencySymbol] = useState('');
  const [loading, setLoading] = useState(false);

  const prefillForm = () => {
    setName(countryData?.name);
    setCurrencyName(countryData?.currency_name);
    setCurrencySymbol(countryData?.currency_symbol);
  };

  const submit = (e) => {
    e.preventDefault();

    const payload = {
      name,
      currency_name,
      currency_symbol,
    };

    if (control === 'Add') {
      if (
        isNull(name) ||
        isNull(currency_name) ||
        isNull(currency_symbol)
      ) {
        toast.error('Please fill all the fields');
        return;
      }
      setLoading(true);

      api()
        .post('/admin/country', payload)
        .then((res) => {
          setLoading(false);
          toast.success('Country successfully added!');
          fetchCountries();
          closeModal();
        })
        .catch((err) => {
          parseMessage(err);
          setLoading(false);
        });
    } else {
      if (
        isNull(name) ||
        isNull(currency_name) ||
        isNull(currency_symbol)
      ) {
        toast.error('Please fill all the fields');
        return;
      }

      setLoading(true);

      api()
        .patch(`/admin/country/${countryData.id}`, payload)
        .then(() => {
          setLoading(false);
          toast.success('Country successfully updated!');
          fetchCountries();
          closeModal();
        })
        .catch((err) => {
          parseMessage(err);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    prefillForm();
  }, [countryData]);

  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      onRequestClose={closeModal}
    >
      <div className="p-2">
        <p className="text-center">{control} Country</p>
        <form onSubmit={submit}>
          <div className="form-group">
            <label>
              Name <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              required
              defaultValue={name}
              placeholder="Enter country name"
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>
              Currency Symbol <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              type="text"
              name="currency_symbol"
              required
              defaultValue={currency_symbol}
              placeholder="Enter currency symbol"
              onChange={(e) => setCurrencySymbol(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>
              Currentcy Name <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              type="text"
              name="currency_name"
              required
              defaultValue={currency_name}
              placeholder="Enter currency name"
              onChange={(e) => setCurrencyName(e.target.value)}
            />
          </div>

          <div className="text-center mt-4">
            {loading && (
              <>
                <i
                  className="fas fa-circle-notch fa-spin"
                  style={{ color: '#F78567', marginRight: 20 }}
                ></i>
              </>
            )}
            {!loading && (
              <>
                <button
                  type="submit"
                  className="btn btn-md btn-primary loading m-2"
                >
                  Save Changes
                </button>
              </>
            )}
            <button
              className="btn btn-md btn-secondary"
              onClick={closeModal}
            >
              Dismiss
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}
